import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Logger } from '../../common/utils';
import { deserializeConsents, getConsentTimestamp, serializeConsents, StatusCodeError } from './utils';
var BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
var POST_CONSENTS_URL = "".concat(BASE_CONSENTS_URL, "/user");
var GET_CONSENTS_URL = "".concat(POST_CONSENTS_URL, "/consents/cookies");
export var buildConsentPreferences = function buildConsentPreferences(consentData) {
  if (consentData) {
    var serializedConsents = serializeConsents(consentData);
    var consentTimestamp = getConsentTimestamp(consentData);
    return {
      consentToken: serializedConsents,
      consentTimestamp: consentTimestamp
    };
  }

  // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
  return {
    consentToken: serializeConsents({}),
    consentHubInaccessible: true
  };
};
var fetchConsentPreferences = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var origin, getFromConsentHubURL, response, consentData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          origin = window.location.origin;
          getFromConsentHubURL = "".concat(origin).concat(GET_CONSENTS_URL);
          _context.prev = 2;
          _context.next = 5;
          return fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 5:
          response = _context.sent;
          if (response.ok) {
            _context.next = 8;
            break;
          }
          throw new Error("Failed to fetch preferences from ConsentHub with status: ".concat(response.status));
        case 8:
          _context.next = 10;
          return response.json();
        case 10:
          consentData = _context.sent;
          return _context.abrupt("return", buildConsentPreferences(consentData));
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](2);
          Logger.errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: _context.t0.message || ''
          });
          return _context.abrupt("return", buildConsentPreferences());
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 14]]);
  }));
  return function fetchConsentPreferences() {
    return _ref.apply(this, arguments);
  };
}();
var buildConsentRequestBody = function buildConsentRequestBody(unpackedUserPreferences, displayedTextMap) {
  var _window$location = window.location,
    origin = _window$location.origin,
    pathname = _window$location.pathname;
  var deserializedConsents = deserializeConsents(unpackedUserPreferences, displayedTextMap);

  // Type guard here so TS knows we're working with ConsentPreferenceV003
  var action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
  var consentRequestBody = {
    action: action,
    // If there are no consents, it's a first time fill, otherwise it's an update action
    consents: deserializedConsents,
    formUrl: "".concat(origin).concat(pathname),
    locale: 'UNKNOWN',
    site: 'atlassian',
    source: 'COOKIE_PREFERENCES'
  };
  return JSON.stringify(consentRequestBody);
};
var saveConsentPreferences = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(unpackedUserPreferences, displayedTextMap) {
    var saveToConsentHubURL, response, errMsg, errWithStatusCode;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          saveToConsentHubURL = "".concat(window.location.origin).concat(POST_CONSENTS_URL);
          _context2.prev = 1;
          _context2.next = 4;
          return fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
          });
        case 4:
          response = _context2.sent;
          if (!(!response.ok || response.status !== 202 && response.status !== 200)) {
            _context2.next = 9;
            break;
          }
          errMsg = "Failed to save preferences to ConsentHub with status: ".concat(response.status);
          errWithStatusCode = new StatusCodeError(errMsg, response.status);
          throw errWithStatusCode;
        case 9:
          _context2.next = 15;
          break;
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](1);
          Logger.errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: _context2.t0.message || ''
          });
          // Re-throw to any encapsulating logic, a la `setConsentToken()`
          throw _context2.t0;
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 11]]);
  }));
  return function saveConsentPreferences(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export { fetchConsentPreferences, saveConsentPreferences };